// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__W8gx4","label":"Radio_label__27_hZ","checkMark":"Radio_checkMark__MWhWr","disabled":"Radio_disabled__2CsU3"};